import { Box, Image, Text, List, ListItem, ListIcon } from '@chakra-ui/react'
import { FaCircle } from 'react-icons/fa'
import logoImg from 'assets/img/logo.svg'
import { useTranslation } from 'react-i18next'

const Info: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      w="50%"
      p="16"
      pb="300px"
      display={{ base: 'none', lg: 'block' }}
      data-testid="Info"
    >
      <Image src={logoImg} maxW="253px" />
      <Text
        fontWeight="semibold"
        color="white"
        fontSize="30px"
        lineHeight="39px"
        mt="14"
      >
        {t('description')}
      </Text>

      <List spacing={6} mt="50px" color="white">
        <ListItem
          background="rgba(255, 255, 255, 0.09)"
          borderRadius="md"
          p="8px 12px"
          listStyleType="disc"
          display="inline-flex"
          alignItems="center"
          rowGap="8px"
        >
          <ListIcon as={FaCircle} color="primary.01" height="8px" width="8px" />
          {t('advantages.01')}
        </ListItem>

        <ListItem
          background="rgba(255, 255, 255, 0.09)"
          borderRadius="md"
          p="8px 12px"
          listStyleType="disc"
          display="inline-flex"
          alignItems="center"
          rowGap="8px"
        >
          <ListIcon as={FaCircle} color="primary.01" height="8px" width="8px" />
          {t('advantages.02')}
        </ListItem>
        <ListItem
          background="rgba(255, 255, 255, 0.09)"
          borderRadius="md"
          p="8px 12px"
          listStyleType="disc"
          display="inline-flex"
          alignItems="center"
          rowGap="8px"
        >
          <ListIcon as={FaCircle} color="primary.01" height="8px" width="8px" />
          {t('advantages.03')}
        </ListItem>
        <ListItem
          background="rgba(255, 255, 255, 0.09)"
          borderRadius="md"
          p="8px 12px"
          listStyleType="disc"
          display="inline-flex"
          alignItems="center"
          rowGap="8px"
        >
          <ListIcon as={FaCircle} color="primary.01" height="8px" width="8px" />
          {t('advantages.04')}
        </ListItem>
      </List>

      <Text color="white" fontSize="m" lineHeight="short" mt="44px">
        {t('sub_cta')}
      </Text>
      <Text color="white" opacity={0.7} fontSize="m" lineHeight="short" mt="8">
        {t('closing_cta')}
      </Text>
    </Box>
  )
}

export default Info
